import { render, staticRenderFns } from "./brokerage-catalog-adjust-list.vue?vue&type=template&id=a3b5218c&"
import script from "./brokerage-catalog-adjust-list.vue?vue&type=script&lang=js&"
export * from "./brokerage-catalog-adjust-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports